module.exports = __webpack_public_path__ + "img/rect_blue_left.0573423d.png";